import moment from "moment";
import { HOURS_0_VALUE, addTimezoneOffset } from "./utils";

const DEFAULT_DATE_FORMAT = "yyyy-MM-DD"

export const formatStringDate = (date: string, format = DEFAULT_DATE_FORMAT, useUtc = false, fixMidnightEndDate = false) => {
   let momentDate = moment(date);
   if (fixMidnightEndDate && date.indexOf(HOURS_0_VALUE) != -1) {
      momentDate = momentDate.add(-1, "millisecond");
   }
   if(useUtc)
      momentDate.utc();
   const formattedDate = momentDate.format(format);
   return formattedDate;
}

export const formatMilliseconds = (milliseconds: number, format = DEFAULT_DATE_FORMAT) => {
   const stringTime = new Date(milliseconds).toISOString();
   const utcStringTime = addTimezoneOffset(stringTime);
   const formattedTime = formatStringDate(utcStringTime, format);
   return formattedTime;
}